import {
  FileExcelOutlined,
  FilePdfOutlined,

  PlusOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Dropdown,
  Input,
  Menu,
  Pagination,
  Popconfirm,
  Row,
  Space,
  Table,
  Tooltip,
  message,
} from 'antd';
import dayjs from 'dayjs';
import jsPDF from 'jspdf';
import { useEffect, useMemo, useState, useCallback, useRef } from 'react';
import { CSVLink } from 'react-csv';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useNavigationType, useLocation  } from 'react-router-dom';
import { font } from '../../Common/font';
import { ReactComponent as Archive } from '../../Images/archive.svg';
import { ReactComponent as Archiveicon } from '../../Images/Archiveicon.svg';
import { ReactComponent as Back } from '../../Images/Back.svg';
import { ReactComponent as ColumnList } from '../../Images/ColumnList.svg';
import { ReactComponent as EditIcon } from '../../Images/EditIcon.svg';
import { ReactComponent as FilterIcon } from '../../Images/FilterIcon.svg';
import {
  deleteTransporter,
  fetchTransporterList,
  resetTransporterData,

} from '../../slices/transporter';
import moment from 'moment';
import { debounce } from 'lodash';
import { createActivityLog } from '../../slices/activity-log';
import { fetchAndSetIpAddress } from '../../slices/ipSlice';
import logo from '../../Images/alux-logo.png';

export default function TransporterList() {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const ipAddress = useSelector(state => state.ip.ipAddress);
  const { user: currentUser } = useSelector(state => state.auth);
  const { data = [], totalRecord ,loading} = useSelector(state => state.transporter);
  const isMountedRef = useRef(true);
  const latestRequestIdRef = useRef(0);
  const abortControllerRef = useRef();
  const [search, setSearch] = useState(localStorage.getItem('die_text_search_tool') || '');
  const [orderBy, setOrderBy] = useState('');
  const [page, setPage] = useState(1);
  const [pagesize, setPageSize] = useState(100);
  const [dropdownVisible, setDropdownVisible] = useState(false);
 
  const location = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    console.log("🔄 useEffect fired");
    console.log("📍 Pathname:", location.pathname);
    console.log("🗝️ Key:", location.key);
    console.log("🚦 NavigationType:", navigationType);
  }, [location.key]);
  const [checkedList, setCheckedList] = useState([
    "party_name",
    "party_code",
    "opening_balance",
    "balance_type",
    "is_cash_amount",
    "address",
    "city",
    "pincode",
    "mobile_no_sms",
    "mobile_no",
    "phone_no",
    "email_id",
    "send_sms_type",
    "is_active",
    "id",
    "action",
  ]);

  useEffect(() => {

    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  useEffect(() => {

    if (!ipAddress) {
      dispatch(fetchAndSetIpAddress());
    }
  }, [dispatch, ipAddress]);

  const debouncedSearch = useMemo(
    () => debounce((query) => {
      if (!isMountedRef.current) return;
   
      // Cancel previous request
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
      abortControllerRef.current = new window.AbortController();
      const signal = abortControllerRef.current.signal;
      latestRequestIdRef.current += 1;
      const requestId = latestRequestIdRef.current;
      if (query.length >= 3 || query.length === 0) {
        dispatch(resetTransporterData());
        dispatch(fetchTransporterList({ 
          page: 1, 
          pagesize,
          ...(query ? { search: query } : {}),
          ...(orderBy ? { ordering: orderBy } : {}),
          signal,
          requestId,
        }))
      
        setPage(1);
      } 
    }, 300),
    [dispatch, pagesize, orderBy]
  );

  useEffect(() => {
 
    if (!isMountedRef.current) return;
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    abortControllerRef.current = new window.AbortController();
    const signal = abortControllerRef.current.signal;
    latestRequestIdRef.current += 1;
    const requestId = latestRequestIdRef.current;
    dispatch(resetTransporterData());
    dispatch(fetchTransporterList({
      page,
      pagesize,
      ...(search ? { search } : {}),
      ...(orderBy ? { ordering: orderBy } : {}),
      signal,
      requestId,
    }))
    .then(() => {
      if (isMountedRef.current && requestId === latestRequestIdRef.current) {
        // Only update if this is the latest request
      }
    });
  }, [dispatch, page, pagesize, orderBy, search]);

  useEffect(() => {

    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const resetFilter = useCallback(() => {
    setSearch('');
    setOrderBy('');
    setPage(1);

    localStorage.removeItem('die_text_search_tool');
    localStorage.removeItem('die_group_search_tool');
    dispatch(resetTransporterData());
    dispatch(fetchTransporterList({ page: 1, pagesize }));
  }, [dispatch, pagesize]);

  const handlePageChange = useCallback((newPage) => {
    setPage(newPage);
  }, []);

  const handlePageSizeChange = useCallback((current, size) => {
    setPage(1);
    setPageSize(size);
  }, []);

  const sortingMap = useMemo(() => ({
    'party_name': { asc: 'party_name', desc: '-party_name' },
    'party_code': { asc: 'party_code', desc: '-party_code' },
    'opening_balance': { asc: 'opening_balance', desc: '-opening_balance' },
    'balance_type': { asc: 'balance_type', desc: '-balance_type' },
    'is_cash_amount': { asc: 'is_cash_amount', desc: '-is_cash_amount' },
    'address': { asc: 'address', desc: '-address' },
    'city': { asc: 'city', desc: '-city' },
    'pincode': { asc: 'pincode', desc: '-pincode' },
    'mobile_no_sms': { asc: 'mobile_no_sms', desc: '-mobile_no_sms' },
    'mobile_no': { asc: 'mobile_no', desc: '-mobile_no' },
    'phone_no': { asc: 'phone_no', desc: '-phone_no' },
    'email_id': { asc: 'email_id', desc: '-email_id' },
    'send_sms_type': { asc: 'send_sms_type', desc: '-send_sms_type' },
    'is_active': { asc: 'is_active', desc: '-is_active' },
    'created_at': { asc: 'created_at', desc: '-created_at' },
    'updated_at': { asc: 'updated_at', desc: '-updated_at' },
    'created_by': { asc: 'created_by__username', desc: '-created_by__username' },
    'updated_by': { asc: 'updated_by__username', desc: '-updated_by__username' },
  }), []);

  const GetSortingEnumValue = useCallback((sortField, sortOrder) => {
    const field = sortingMap[sortField];
    if (field) {
      return sortOrder === 'ascend' ? field.asc : field.desc;
    }
    return 'id';
  }, [sortingMap]);

  const handleTableChange = useCallback((pagination, filters, sorter) => {
    if (sorter?.columnKey && sorter.order) {
      const newOrderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
      setOrderBy(newOrderBy);
    }
    if (pagination?.pageSize) setPageSize(pagination.pageSize);
    if (pagination?.current) setPage(pagination.current);
  }, [GetSortingEnumValue]);

  const handleSearch = useCallback((e) => {
    const value = e.target.value;
    setSearch(value);
    if (value.length >= 3 || value.length === 0) {
      dispatch(resetTransporterData());
    }
    debouncedSearch(value);
  }, [debouncedSearch, dispatch]);

  const handleEdit = useCallback((data) => {
    navigate(`/edit-transporter/${data.id}`);
  }, [navigate]);

  const handleDelete = useCallback((id) => {
    if (!id) {
      message.error('Missing ID for deletion!');
      return;
    }

    dispatch(deleteTransporter(id))
      .unwrap()
      .then(() => {
        message.success('Transporter Archive Successfully!');
      })
      .catch(err => {
  
        message.error(`Error: ${err || 'Failed to delete the profile.'}`);
      });
  }, [dispatch]);

  const debouncedAPICall = useMemo(() =>
    debounce((query) => {
      if (query.length >= 3) {
        dispatch(fetchTransporterList({ search: query }));
        localStorage.setItem('die_text_search_tool', query);
      }
    }, 1000), [dispatch]
  );

  useEffect(() => {

    return () => {
      debouncedAPICall.cancel();
    };
  }, [debouncedAPICall]);



  const handleColumnVisibilityChange = useCallback((checkedValues) => {
    setCheckedList(checkedValues);
  }, []);

  const columns = useMemo(() => [
    {
      title: 'Sr. No.',
      dataIndex: 'id',
      key: 'id',
      width: '50px',
      render: (text, record, index) => (page - 1) * pagesize + index + 1,
      sorter: false,
      align: 'center'
    },
    {
        title: "Party Name",
        dataIndex: "party_name",
        key: "party_name",
        sorter: true,
        render: (text) => text || "N/A",
      },
      {
        title: "Party Code",
        dataIndex: "party_code",
        key: "party_code",
        sorter: true,
        render: (text) => text || "N/A",
      },
      {
        title: "Opening Balance",
        dataIndex: "opening_balance",
        key: "opening_balance",
        sorter: true,
        render: (text) => <span style={{ textAlign: "end" }}>{text ?? 0}</span>,
      },
      {
        title: "Balance Type",
        dataIndex: "balance_type",
        key: "balance_type",
        sorter: true,
      
        render: (text) => text || "N/A",
      },
      {
        title: "Is This Cash Account",
        dataIndex: "is_cash_amount",
        key: "is_cash_amount",
       
        sorter: true,
        render: (val) => (val ? "Yes" : "No"),
      },
      {
        title: "Address",
        dataIndex: "address",
        key: "address",
        sorter: true,
        render: (text) => text || "N/A",
      },
      {
        title: "City",
        dataIndex: "city",
        key: "city",
        sorter: true,
        render: (text) => text || "N/A",
      },
      {
        title: "Pincode",
        dataIndex: "pincode",
        key: "pincode",
        sorter: true,
        render: (text) => text || "N/A",
      },
      {
        title: "Mobile No. (SMS)",
        dataIndex: "mobile_no_sms",
        key: "mobile_no_sms",
        sorter: true,
        render: (text) => text || "N/A",
      },
      {
        title: "Mobile No.",
        dataIndex: "mobile_no",
        key: "mobile_no",
        width: '120px',
        sorter: true,
        render: (text) => text || "N/A",
      },
      {
        title: "Phone No.",
        dataIndex: "phone_no",
        key: "phone_no",
        width: '120px',
        sorter: true,
        render: (text) => text || "N/A",
      },
      {
        title: "Email ID",
        dataIndex: "email_id",
        key: "email_id",
        sorter: true,
        render: (text) => text || "N/A",
      },
      {
        title: "Sending SMS Type",
        dataIndex: "send_sms_type",
        key: "send_sms_type",
        sorter: true,
        render: (text) => text || "N/A",
      },
      {
        title: "Is Active",
        dataIndex: "is_active",
        key: "is_active",
        sorter: true,
        render: (text) => text || "N/A",
      },
    {
      title: 'Created At',
      dataIndex: 'created_at',
      key: 'created_at',
      width: '100px',
      sorter: true,
      render: record => (
        <span>
          {record ? dayjs(record).format('DD-MM-YYYY HH:mm') : 'N/A'}
        </span>
      ),
    },
    {
      title: 'Created By',
      dataIndex: 'created_by_name',
      key: 'created_by',
      width: '100px',
      sorter: true,
      render: record => (
        <span>
          {record ? record : 'N/A'}
        </span>
      ),
    },
    {
      title: 'Updated At',
      dataIndex: 'updated_at',
      key: 'updated_at',
      width: '100px',
      sorter: true,
      render: record => (
        <span>
          {record?.trim() ? dayjs(record).format('DD-MM-YYYY HH:mm') : 'N/A'}
        </span>
      ),
    },
    {
      title: 'Updated By',
      dataIndex: 'updated_by_name',
      key: 'updated_by',
      width: '100px',
      sorter: true,
      render: record => (
        <span>
              {record ? record : 'N/A'}
        </span>
      ),
    },
   
    {
      title: 'Action',
      dataIndex: 'id',
      key: 'action',
      width: '100px',
      fixed: 'right',
      render: (text, record) => (
        <Space>
          {currentUser.permissions.permissions.die.includes('change_dietool') && (
            <Tooltip placement="top" title={'Edit'}>
              <span onClick={() => handleEdit(record)}>
                <EditIcon style={{ cursor: 'pointer' }} />
              </span>
            </Tooltip>
          )}
          {currentUser.permissions.permissions.die.includes('delete_dietool') && (
            <Tooltip placement="top" title={'Archive'}>
              <Popconfirm
                title="Are you sure you want to archive this record?"
                onConfirm={() => handleDelete(record.id)}
                onCancel={() => message.info('Action cancelled')}
                okText="Yes"
                cancelText="No"
              >
                <Archive style={{ cursor: 'pointer' }} />
              </Popconfirm>
            </Tooltip>
          )}
        </Space>
      ),
    },
  ], [page, pagesize, currentUser, handleEdit, handleDelete]);

  const filteredColumns = columns.filter(column =>
    checkedList.includes(column.key),
  );

  const columnMenu = (
    <Menu className="packagelistdropdown">
      <Menu.Item key="columnMenu">
        <Checkbox.Group value={checkedList} onChange={handleColumnVisibilityChange}>
          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Checkbox value="id" disabled>
                Sr. No.
              </Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="party_name">Party Name</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="party_code">Party Code</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="opening_balance">Opening Balance</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="balance_type">Balance Type</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="is_cash_amount">Is This Cash Account</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="address">Address</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="city">City</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="pincode">Pincode</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="mobile_no_sms">Mobile No. (SMS)</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="mobile_no">Mobile No.</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="phone_no">Phone No.</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="email_id">Email ID</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="send_sms_type">Sending SMS Type</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="is_active">Is Active</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="created_at">Created At</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="created_by">Created By</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="updated_at">Updated At</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="updated_by">Updated By</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="action" disabled>
                Action
              </Checkbox>
            </Col>
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );

  const exportTransporterToPDF = pdfdata => {
  
    const pdf = new jsPDF('l', 'pt', 'a4');
    pdf.addFileToVFS('WorkSans-normal.ttf', font);
    pdf.addFont('WorkSans-normal.ttf', 'WorkSans', 'normal');
    pdf.setFont('WorkSans');

    const allColumns = [
        { header: 'Party Name', dataKey: 'party_name', field: 'party_name' },
        { header: 'Party Code', dataKey: 'party_code', field: 'party_code' },
        { header: 'Opening Balance', dataKey: 'opening_balance', field: 'opening_balance' },
        { header: 'Balance Type', dataKey: 'balance_type', field: 'balance_type' },
        { header: 'Is This Cash Account', dataKey: 'is_cash_amount', field: 'is_cash_amount' },
        { header: 'Address', dataKey: 'address', field: 'address' },
        { header: 'City', dataKey: 'city', field: 'city' },
        { header: 'Pincode', dataKey: 'pincode', field: 'pincode' },
        { header: 'Mobile No. (SMS)', dataKey: 'mobile_no_sms', field: 'mobile_no_sms' },
        { header: 'Mobile No.', dataKey: 'mobile_no', field: 'mobile_no' },
        { header: 'Phone No.', dataKey: 'phone_no', field: 'phone_no' },
        { header: 'Email ID', dataKey: 'email_id', field: 'email_id' },
        { header: 'Sending SMS Type', dataKey: 'send_sms_type', field: 'send_sms_type' },
        { header: 'Is Active', dataKey: 'is_active', field: 'is_active' },
      { header: 'Created At', dataKey: 'created_at', field: 'created_at' },
      { header: 'Created By', dataKey: 'created_by', field: 'created_by' },
      { header: 'Updated At', dataKey: 'updated_at', field: 'updated_at' },
      { header: 'Updated By', dataKey: 'updated_by', field: 'updated_by' },
    ];

    const columns = Array.isArray(checkedList)
      ? allColumns.filter(col => checkedList.includes(col.field))
      : [];

      const rows = Array.isArray(pdfdata)
      ? 
    
      pdfdata.map(item => {
          const row = {};
          columns.forEach(col => {
            switch (col.field) {
              case 'party_name':
                row.party_name = item.party_name || 'N/A';
                break;
              case 'party_code':
                row.party_code = item.party_code || 'N/A';
                break;
              case 'opening_balance':
                row.opening_balance = item.opening_balance || '0.00';
                break;
              case 'balance_type':
                row.balance_type = item.balance_type || 'N/A';
                break;
              case 'is_cash_amount':
                row.is_cash_amount = item.is_cash_amount ? 'Yes' : 'No';
                break;
              case 'address':
                row.address = item.address || 'N/A';
                break;
              case 'city':
                row.city = item.city || 'N/A';
                break;
              case 'pincode':
                row.pincode = item.pincode || 'N/A';
                break;
              case 'mobile_no_sms':
                row.mobile_no_sms = item.mobile_no_sms || 'N/A';
                break;
              case 'mobile_no':
                row.mobile_no = item.mobile_no || 'N/A';
                break;
              case 'phone_no':
                row.phone_no = item.phone_no || 'N/A';
                break;
              case 'email_id':
                row.email_id = item.email_id || 'N/A';
                break;
              case 'send_sms_type':
                row.send_sms_type = item.send_sms_type || 'N/A';
                break;
              case 'is_active':
                row.is_active = item.is_active || 'N/A';  
                break;
              case 'created_at':
                row.created_at = item.created_at
                  ? moment(item.created_at, 'DD-MM-YYYY HH:mm').format('DD-MM-YYYY')
                  : 'N/A';
                break;
              case 'created_by':
               
                row.created_by = item.created_by_name || 'N/A';
                break;
              case 'updated_at':
                row.updated_at = item.updated_at
                  ? moment(item.updated_at, 'DD-MM-YYYY HH:mm').format('DD-MM-YYYY')
                  : 'N/A';
                break;
              case 'updated_by':
                row.updated_by = item.updated_by_name || 'N/A';
                break;
              default:
                row[col.field] = item[col.field] || 'N/A';
                break;
            }
          });
          return row;
        })
      :  [];
    

    const pageWidth = pdf.internal.pageSize.getWidth();
    const imgWidth = 150;
    const imgHeight = 40;
    pdf.addImage(logo, 'PNG', pageWidth - imgWidth - 40, 20, imgWidth, imgHeight);
    pdf.setFontSize(16);
    pdf.text('Transporter List', pageWidth / 2, 40, { align: 'center' });
    pdf.autoTable({
      columns,
      body: rows,
      startY: 80,
      theme: 'grid',
      tableWidth: 'auto', // Use available width
      margin: { top: 80, right: 10, left: 10, bottom: 40 }, // Reduce side margins
      styles: {
        halign: 'center',
        overflow: 'linebreak',
        cellPadding: 3.8,
        lineWidth: 0.5,
        lineColor: [0, 0, 0],
        textColor: [0, 0, 0],
        fontSize: 8,
      },
      headStyles: {
        textColor: [0, 0, 0],
        fontStyle: 'bold',
        lineWidth: 0.5,
        lineColor: [0, 0, 0],
        fillColor: false,
        fontSize: 9,
      },
      // Only set columnStyles for columns with long text if needed
      columnStyles: {
        address: { cellWidth: 60, halign: 'left' },
        email_id: { cellWidth: 60, halign: 'left' },
      },
      didDrawPage: (data) => {
        const pageHeight = pdf.internal.pageSize.getHeight();
        const pageWidth = pdf.internal.pageSize.getWidth();

        pdf.setFontSize(8);
        pdf.setTextColor(100);
        const now = moment();
        const dateStr = `${now.format("DD-MM-YYYY hh:mm:ss A")}`;
        pdf.text(dateStr, 40, pageHeight - 20);

        const pageStr = `Page ${data.pageNumber}`;
        pdf.text(pageStr, pageWidth - 40, pageHeight - 20, { align: "right" });
      },
      willDrawCell: pdfdata => {
        if (pdfdata.cell.text.length > 0) {
          const text = pdfdata.cell.text[0];
          if (text && text.length > 30) {
            pdfdata.cell.text[0] = text.substring(0, 27) + '...';
          }
        }
      },
    });
    pdf.save(`Transporter${new Date().toISOString().split('T')[0]}.pdf`);
    dispatch(
      createActivityLog({
        action: 'DOWNLOAD',
        module_name: 'Transporter',
        ip_address: ipAddress,
        discription: 'Transporter pdf download successfully!',
      }),
    );
  };

  const csvheaders = [
    { label: 'Party Name', key: 'party_name' },
  { label: 'Party Code', key: 'party_code' },
  { label: 'Opening Balance', key: 'opening_balance' },
  { label: 'Balance Type', key: 'balance_type' },
  { label: 'Is This Cash Account', key: 'is_cash_amount' },
  { label: 'Address', key: 'address' },
  { label: 'City', key: 'city' },
  { label: 'Pincode', key: 'pincode' },
  { label: 'Mobile No. (SMS)', key: 'mobile_no_sms' },
  { label: 'Mobile No.', key: 'mobile_no' },
  { label: 'Phone No.', key: 'phone_no' },
  { label: 'Email ID', key: 'email_id' },
  { label: 'Sending SMS Type', key: 'send_sms_type' },
  { label: 'Is Active', key: 'is_active' },
    { label: 'Created At', key: 'created_at' },
    { label: 'Created By', key: 'created_by' },
    { label: 'Updated At', key: 'updated_at' },
    { label: 'Updated By', key: 'updated_by' },
  ];
  const csvFilterheaders = csvheaders.filter(column =>
    checkedList.includes(column.key),
  );

  const csvListData = data?.map((item, index) => ({
    party_name: item?.party_name || 'N/A',
  party_code: item?.party_code || 'N/A',
  opening_balance: item?.opening_balance ?? '0',
  balance_type: item?.balance_type || 'N/A',
  is_cash_amount: item?.is_cash_amount ? 'Yes' : 'No',
  address: item?.address || 'N/A',
  city: item?.city || 'N/A',
  pincode: item?.pincode || 'N/A',
  mobile_no_sms: item?.mobile_no_sms || 'N/A',
  mobile_no: item?.mobile_no || 'N/A',
  phone_no: item?.phone_no || 'N/A',
  email_id: item?.email_id || 'N/A',
  send_sms_type: item?.send_sms_type || 'N/A',
  is_active: item?.is_active ,
    created_at: item?.created_at
      ? moment(item?.created_at).format('DD-MM-YYYY')
      : 'N/A',
    created_by: item?.created_by
      ? `${item?.created_by.first_name} ${item?.created_by.last_name}`
      : 'N/A',
    updated_at: item?.updated_at
      ? moment(item?.updated_at).format('DD-MM-YYYY')
      : 'N/A',
    updated_by: item?.updated_by
      ? `${item?.updated_by.first_name} ${item?.updated_by.last_name}`
      : 'N/A',
  }));

  const activityLog = async () => {
    dispatch(
      createActivityLog({
        action: 'DOWNLOAD',
        module_name: 'Transporter',
        ip_address: ipAddress,
        discription: 'Transporter excel download successfully!',
      }),
    );
  }
  return (
    <div className='mainwrap'>
      <div className="sticyaction">
        <Row className="pagenamerow mb-0" justify="space-between" align="middle">
          <Col>
            <h2 style={{ margin: 0 }}>Transporter List</h2>
            <div className="bredcrumbwrp">
                <Link
                  className="back"
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  <Back /> BACK
                </Link>
                <Breadcrumb
                  items={[
                    { title: <Link to="/dashboard">Home</Link> },
                    { title: 'Transporter List' },
                  ]}
                />
              </div>
          </Col>
          <Col>
            <Space size="small">
              <Input
                placeholder="Search"
                className='searchbox'
                prefix={<SearchOutlined />}
                value={search}
                onChange={handleSearch}
                style={{ width: 200 }}
              />
              <Tooltip placement="top" title="Reset Filter">
                <Button
                  type="primary"
                  disabled={!search && !orderBy}
                  className="iconlink"
                  onClick={resetFilter}
                >
                  <FilterIcon />
                </Button>
              </Tooltip>
              {currentUser.permissions.permissions.die.includes(
                'download_profile_tool_excel_copy',
              ) && (
                  <Tooltip placement="top" title={'Export Excel'}>
                    <Button
                      type="primary"
                      className="iconlink"
                      style={{ width: '10px' }}
                      onClick={activityLog}
                    >
                      <CSVLink
                        filename={'profile_tool.csv'}
                        data={csvListData}
                        className="iconlink"
                        headers={csvFilterheaders}
                      >
                        <FileExcelOutlined />
                      </CSVLink>
                    </Button>
                  </Tooltip>
                )}
              {currentUser.permissions.permissions.die.includes(
                'download_profile_tool_pdf_copy',
              ) && (
                  <Tooltip placement="top" title={'Export PDF'}>
                    <Button
                      type="primary"
                      className="iconlink"
                      onClick={() => exportTransporterToPDF(data)}
                    >
                      <FilePdfOutlined />
                    </Button>
                  </Tooltip>
                )}
              {currentUser.permissions.permissions.die.includes(
                'add_dietool',
              ) && (
                  <Link to="/add-transporter">
                    <Tooltip placement="top" title={'Add Transporter'}>
                      <Button type="primary" icon={<PlusOutlined />}>
                        Add Transporter
                      </Button>
                    </Tooltip>
                  </Link>
                )}
              {currentUser.permissions.permissions.die.includes(
                'delete_dietool',
              ) && (
                  <Tooltip placement="top" title="Archive">
                    <Link to="/archive-transporter" className="iconlink">
                      {' '}
                      <Archiveicon style={{ cursor: 'pointer' }} />
                    </Link>
                  </Tooltip>
                )}
                 <div className="gridiconswrap">
              <Tooltip placement="topLeft" title="Column Filter Options">
                <Dropdown
                  overlay={columnMenu}
                  trigger={['click']}
                  placement="bottomRight"
                  visible={dropdownVisible}
                  onVisibleChange={setDropdownVisible}
                >
                  <Button
                    type="primary"
                    icon={<ColumnList />}
                    onClick={e => e.preventDefault()}
                  />
                </Dropdown>
              </Tooltip>
              </div>
            </Space>
          </Col>
        </Row>
      </div>

      <div className='tablewrp'>
        <Table
          rowKey="id"
          dataSource={data}
          columns={filteredColumns}
          pagination={false}
          loading={loading}
          onChange={handleTableChange}
          scroll={{ x: '1000px' }}
        />
      </div>

      <Pagination
        current={page}
        pageSize={pagesize}
        total={totalRecord}
        showSizeChanger
        onShowSizeChange={handlePageSizeChange}
        pageSizeOptions={["20", "50", "100"]}
        showTotal={total => `Total ${total} items`}
        onChange={handlePageChange}
        locale={{ items_per_page: 'Items / Page' }}
      />


    </div >
  );
}
